// extracted by mini-css-extract-plugin
module.exports = {"Stores":"Stores_Stores__p3Jk4"};